var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-base',{attrs:{"title":_vm.$t(_vm.title)}},[_c('block-base-view',{attrs:{"fields":_vm.fieldsResult}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }